<template>
  <div class="contact-popup-pc">
    <div class="contact-popup-trigger">
      <slot name="trigger"></slot>
    </div>
    <!-- PC端悬停时显示的3个咨询入口 -->
    <div class="contact-popup-hover" @mousedown.stop @mouseup.stop @touchstart.stop>
      <span
        v-for="item in chatActions"
        :key="item.value"
        class="contact-popup-trigger-item"
        @click.stop="handleSelectChatType(item.value)"
      >
        {{ item.label }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { useQiyuChat } from '~/composables/useQiyuChat'

const { openQiyuChat } = useQiyuChat()

const chatActions = [
  { label: '解决方案咨询', value: 'scheme' },
  { label: '产品咨询', value: 'sales' },
  { label: '售后咨询', value: 'afterSales' },
]

/**
 * @description 选择客服类型并打开七鱼会话
 * @param {'scheme'|'sales'|'afterSales'} type - 客服类型
 * @returns {void}
 */
const handleSelectChatType = (type) => {
  openQiyuChat({ type, from: 'chatbot-contact-popup' })
}
</script>

<style lang="scss" scoped>
.contact-popup-pc {
  position: relative;
  display: inline-block;
  width: 100%;

  .contact-popup-trigger {
    width: 100%;
  }

  .contact-popup-hover {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    opacity: 0;
    visibility: hidden;
    transform: translateX(4px);
    transition:
      opacity 0.2s ease,
      visibility 0.2s ease,
      transform 0.2s ease;
    position: absolute;
    right: 100%;
    top: 0;
    margin-right: 8px;
    white-space: nowrap;
    z-index: 1002;
    background: $bg-white;
    width: 124px;
    padding: 4px 0;
    border: 1px solid #e5e6eb;
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba($color-black, 0.1);
    overflow: hidden;
  }

  &:hover {
    .contact-popup-hover {
      opacity: 1;
      visibility: visible;
      transform: translateX(0);
    }
  }

  .contact-popup-trigger-item {
    display: inline-flex;
    align-items: center;
    width: 100%;
    min-height: 36px;
    transition: background 0.2s ease;
    color: $text-title-color;
    cursor: pointer;
    font-size: 14px;
    line-height: 22px;
    padding: 7px 12px;
    touch-action: manipulation;

    // 仅在支持真实 hover 的设备上启用
    @media (hover: hover) and (pointer: fine) {
      &:hover {
        background: $bg-color;
      }
    }
  }
}
</style>
